/**
 * openExternalURL element.
 */
const openExternalURL = {};

// Constants
const SELECTOR = '.hom-js-open-external-url';

/**
 * Attach rateApp element event listener.
 */
openExternalURL.addEventListener = function () {
    $('body').on('click', SELECTOR, function (e) {
        e.preventDefault();

        // Fetch URL dynamically from clicked element
        const externalURL = $(this).attr('data-external-url');

        if (!externalURL) {
            console.error('External URL is missing.');
            return;
        }

        try {
            const DATA = {
                action: 'openURL',
                externalURL: externalURL
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
        } catch (error) {
            console.error(error);
        }
    });
};

module.exports = openExternalURL;
